'use strict';
const angular = require('angular');

export class mailComposerSectionSelectorComponent {
  /*@ngInject*/
  constructor() {
    this.options = [{
      title: 'Plain Text',
      type: 'text',
      description: 'A simple text block; all the template styles remain as defined'
    },{
      title: 'Rich Text',
      type: 'html',
      description: 'A text block with diverse format and styling options; the template style will be overwritten'
    }, {
      title: 'Images',
      type: 'images',
      description: 'A block with images'
    }];

  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok() {
    this.close({$value: this.selectedType});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  getHelpText(type) {
    let idx = this.options.findIndex(o => o.type == type);
    return this.options[idx].description;
  }

}

export default angular.module('conduApp.mailComposerSectionSelectorComponent', [])
  .component('mailComposerSectionSelectorComponent', {
    template: require('./mail-composer-section-selector.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: mailComposerSectionSelectorComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/mail-composer/section-selector/mail-composer-section-selector.component.js